import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import {
    BannerTextType,
    incrementBannerTextGenerationCount,
    setBannerGeneratedText,
    setBannerTextGenerationIsLoading,
    setBannerTextType,
    setBannerTextWasGenerated,
} from 'store/models/bannerTextGeneration';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

interface BannerTextGenerationRequest {
    vacancyId: number;
}

interface BannerTextGenerationResponse {
    description: string;
}

export const fetchBannerGeneratedText = (vacancyId: string, setBannerText: (text: string) => void): AppThunkAction => {
    return (dispatch) => {
        dispatch(setBannerTextGenerationIsLoading(true));

        return fetcher
            .post<BannerTextGenerationRequest, BannerTextGenerationResponse>('/api/v1/banners/text/generate', {
                vacancyId,
            })
            .then((response) => {
                dispatch([
                    setBannerTextWasGenerated(true),
                    setBannerTextType(BannerTextType.Generated),
                    incrementBannerTextGenerationCount(),
                    setBannerGeneratedText(response.description),
                ]);
                setBannerText(response.description);
            })
            .catch((error: Error) => {
                if (error.name !== 'AbortError') {
                    dispatch(addMagritteNotification(MagritteNotificationName.BannerTextGenerationSomethingWentWrong));
                }
            })
            .finally(() => {
                dispatch(setBannerTextGenerationIsLoading(false));
            });
    };
};
